import { forwardRef, type TextareaHTMLAttributes } from 'react'

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid = false, className = '', disabled, ...rest },
  ref,
) {
  const shell = [
    'input-shell',
    'textarea',
    invalid ? 'input-shell--invalid' : '',
    disabled ? 'input-shell--disabled' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <textarea
      ref={ref}
      className={shell}
      aria-invalid={invalid || undefined}
      disabled={disabled}
      style={{ height: 'auto' }}
      {...rest}
    />
  )
})

export default Textarea
